import opentelemetry from '@opentelemetry/api';

export const TRACER_NAME_BUILDER = 'builder';

export const getSpan = (tracerName: string, operation: string) => {
  const tracer = opentelemetry.trace.getTracer(tracerName);
  return tracer.startSpan(operation);
};
